const words = (value) => (value || "").trim().split(/\s+/).filter(Boolean);

// Players loaded by hand only have a full name. With 3+ words we assume
// "Nombre Apellido1 Apellido2" and keep the first surname.
export const surnameFromFullName = (fullName) => {
  const parts = words(fullName);
  if (parts.length === 0) return "";
  if (parts.length <= 2) return parts[parts.length - 1];
  return parts[parts.length - 2];
};

export const playerSurname = (player) => {
  const lastName = words(player?.playerable?.last_name || player?.last_name)[0];
  return lastName || surnameFromFullName(player?.name);
};

// Suggests a participant name made of its players' surnames, keeping the
// "A | B" format the backend uses for couples. The organizer reviews it.
export const suggestSurnameName = (players = []) => players.map(playerSurname).filter(Boolean).join(" | ");
